import * as React from "react"
import type { SVGProps } from "react"
const SvgAlarmOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M16.15 19.71H5a1 1 0 0 1-.71-.28A1 1 0 0 1 4 18.7q0-.43.29-.7a1 1 0 0 1 .71-.3h1v-7q0-.82.21-1.62a6 6 0 0 1 .64-1.53l1.5 1.5A4 4 0 0 0 8 10.71v7h6.2L2.1 5.61a1 1 0 0 1-.28-.7q0-.42.28-.7a1 1 0 0 1 .7-.27q.42 0 .7.27l17 17q.27.28.29.7a1 1 0 0 1-.29.7 1 1 0 0 1-.7.28 1 1 0 0 1-.7-.28zM13.5 4.91a5.8 5.8 0 0 1 3.25 2.12A6 6 0 0 1 18 10.7v2.75q0 .51-.31.75a1.05 1.05 0 0 1-1.38 0q-.3-.27-.31-.77V10.7q0-1.65-1.17-2.82a3.9 3.9 0 0 0-3.68-1.08q-.45.1-.8.25a1.3 1.3 0 0 1-.84.08 1 1 0 0 1-.63-.48 1 1 0 0 1-.14-.68.7.7 0 0 1 .38-.54q.33-.18.68-.3l.7-.23v-.7q0-.62.44-1.06A1.5 1.5 0 0 1 12 2.71q.63 0 1.06.44.45.45.44 1.06zM12 22.71q-.75 0-1.34-.4a1.3 1.3 0 0 1-.59-1.12q0-.2.17-.34a.6.6 0 0 1 .36-.14h2.8q.2 0 .36.14a.4.4 0 0 1 .16.34q0 .7-.58 1.11a2.3 2.3 0 0 1-1.34.41" />
  </svg>
)
export default SvgAlarmOff
